import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { NameProvider } from './context/NameContext';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <NameProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </NameProvider>
  </React.StrictMode>
);

reportWebVitals();
